import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from './components/Header';
import Hero from './components/Hero';
import PortalShowcase from './components/PortalShowcase';
import Profile from './components/Profile';
import Experience from './components/Experience';
import Skills from './components/Skills';
import OZMechanicShowcase from './components/OZMechanicShowcase';
import AIProjects from './components/AIProjects';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';
import CutCutBarbershopShowcase from './components/CutCutBarbershopShowcase';
import Privacy from './components/Privacy.js'; // 👈 new page
import PromoModal from './components/PromoModal';
import MechanicFindersPage from './components/MechanicFindersPage';
import CutCutPage from './components/CutCutPage';
function Home() {
  return (
    <div className="App">
      <PromoModal />
      <Header />
      <main>
        <Hero />
        <PortalShowcase />
        <Profile />
        <Experience />
        <Skills />
        <OZMechanicShowcase />
        <CutCutBarbershopShowcase />
        <AIProjects />
        <Projects />
        <Education />
        <Contact />
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/mechanic-finder" element={<MechanicFindersPage />} />
        <Route path="/cutcut" element={<CutCutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
